<template>

  <div class="inner-box">
    <el-form size="small">
      <div class="content-name">
        <h2 class="dp-ib">기사정보관리</h2>
        <el-form-item label-width="0px" style="float: right;">
          <el-button type="primary" icon="el-icon-search" @click="goOpen">{{ this.$i18n.messages[this.$store.state.locale].search }}</el-button>
        </el-form-item>
      </div>
    </el-form>
    <!-- 검색조건 영역 -->
    <div class="search-form">
      <el-form size="mini" label-width="80px">
        <el-row style="margin-bottom: 0px;">
          <el-col :span="4">
            <el-form-item label="AS기사">
              <el-select v-model="selectId">
                <el-option value=''  label="전체">==전체==</el-option>
                <el-option
                    v-for="item in combos['agerntUser']"
                    :key="item.key"
                    :value="parseInt(item.key)"
                    :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="grid-wrap">
      <ag-grid-vue ref="agentGrid"
                   style="width: 100%; height: 50vh; padding-top: 40px;"
                   class="ag-theme-alpine grid_search_height"
                   rowSelection="single"
                   :columnDefs="columnDefs"
                   :gridOptions="gridOptions"
                   :rowData="data"
                   :defaultColDef="defaultColDef"
                   :frameworkComponents="frameworkComponents"
                   @grid-ready="onReadyAgent"
                   @selection-changed="onSelectionChangedAgent"
      />
    </div>

    <div class="table-header">
      <el-form style="display: grid; float: right; padding-top: 40px;" size="small">
        <el-form-item label-width="0px">
          <el-button type="primary" icon="el-icon-document-add" @click="save">저장</el-button>
          <el-button type="info" icon="el-icon-close" @click="cancel">취소</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-form size="mini" :model="form" ref="catInfoForm" class="components">

      <el-row>
        <el-col>
          <el-col :span="2">
            <el-form-item label="ID">
              <el-input v-model="form.userId" v-show="false"></el-input>
              <el-input v-model="form.asAgentId" v-show="false"></el-input>
              <el-input v-model="form.userCd" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item label="그룹구분">
                <el-input v-model="form.groupNm" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item label="직급" prop="catNm">
              <el-input v-model="form.positionCd"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="성명" prop="catNm">
              <el-input v-model="form.userNm" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="차량번호" prop="catNm">
              <el-input v-model="form.carNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="담당지역" prop="catNm">
              <el-input v-model="form.area"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="휴대폰" prop="catNm">
              <el-input v-model="form.hpNo"></el-input>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>

      <el-row>
      <el-form-item label="평일" style="color: red;">
        <el-row>
          <el-col>
            <el-col :span="4">
              <el-form-item label="오전">
                <el-input v-model="form.weekMorning"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="오후" prop="catNm">
                <el-input v-model="form.weekAfterNoon"></el-input>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>
      </el-form-item>
      </el-row>

      <el-row>
      <el-form-item label="토요일" style="color: red;">
        <el-row>
          <el-col>
            <el-col :span="4">
              <el-form-item label="오전">
                <el-input v-model="form.weekEndMorning"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="오후" prop="catNm">
                <el-input v-model="form.weekEndAfterNoon"></el-input>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>
      </el-form-item>
      </el-row>

    </el-form>
  </div>

</template>

<script>
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import _ from "lodash";

export default {
  name: "AgentInfo",
  data() {
    return {
      form: {
        userCd: "",
        groupUid: "",
        positionCd: "",
        userNm: "",
        carNo: "",
        enterDt: "",
        weekMorning: "",
        weekAfterNoon: "",
        weekEndMorning: "",
        weekEndAfterNoon: "",
        groupNm:"",
        agentUserId: "",
        userId: "",
        addr1:"",
        addr2:"",
        area:"",
        asAgentFullNm:"",
        asAgentId:"",
        asAgentNm:"",
        asAgentType:"",
        businessNo:"",
        businessStatus:"",
        businessType:"",
        companyId:"",
        contractEndDt:"",
        contractStartDt:"",
        contractStatus:"",
        createDt:"",
        creatorId:"",
        creatorNm:"",
        deleteYn:"",
        description:"",
        email:"",
        hpNo:"",
        keyManNm:"",
        telNo:"",
        updateDt:"",
        updatorId:"",
        updatorNm:"",
      },
      defForm: {
        userCd: "",
        groupUid: "",
        positionCd: "",
        userNm: "",
        carNo: "",
        enterDt: "",
        weekMorning: "",
        weekAfterNoon: "",
        weekEndMorning: "",
        weekEndAfterNoon: "",
        groupNm:"",
        agentUserId: "",
        userId: "",
        addr1:"",
        addr2:"",
        area:"",
        asAgentFullNm:"",
        asAgentId:"",
        asAgentNm:"",
        asAgentType:"",
        businessNo:"",
        businessStatus:"",
        businessType:"",
        companyId:"",
        contractEndDt:"",
        contractStartDt:"",
        contractStatus:"",
        createDt:"",
        creatorId:"",
        creatorNm:"",
        deleteYn:"",
        description:"",
        email:"",
        hpNo:"",
        keyManNm:"",
        telNo:"",
        updateDt:"",
        updatorId:"",
        updatorNm:"",
      },
      // eslint-disable-next-line vue/no-dupe-keys
      tapName: "default",
      columnDefs: [],
      data: [],
      gridOptions: {},
      defaultColDef: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
      },
      combos: {
        'agerntUser' : [],        //AS기사
      },
      selectId:"",
      frameworkComponents: null,
    };
  },
  methods: {
    setInfo() {
      Object.assign(this.form, this.custParam);
    },
    defaultInfo(){
      this.tapName = "default";
    },
    agentInfo(){
      this.tapName = "agent";
    },
    timeTableInfo(){
      this.tapName = "time";
    },
    goOpen(){
      this.$store.commit('loading')
      this.$http.post("/api/asAgentMng/detail/agent", {
          companyId: this.$store.state.loginInfo.compCd,
          asAgentId: this.$store.state.loginInfo.asAgentId,
          userId : this.selectId == '' ? 0 : this.selectId,
          useYn : 'Y',
          processTime: ""
        }).then(response => {
            this.data = response.data;
        }).finally(() => {
            this.$store.commit('finish');
        });
    },
    onReadyAgent(params) {
      //메인그리드 api 정의
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      this.gridApi.sizeColumnsToFit();

      this.init();
      this.goOpen();
    },
    onSelectionChangedAgent(event) {
      this.gridApi = this.gridOptions.api;
      this.columnApi = this.gridOptions.columnApi;
      const voRow = this.gridApi.getSelectedRows() //선택된 Row
      this.$http
          .post("/api/asAgentMng/detail/agent/item", {
            companyId: this.$store.state.loginInfo.compCd,
            userId: voRow[0].userId,
            processTime : ""
          })
          .then(response => {
            if(response.data[0]){
              this.form = response.data[0];
              this.form.groupUid == 6 ? this.form.groupNm = '센터관리자' : this.form.groupNm = 'AS기사';
            }
          }).finally(() => {
      });
    },
    createColumnDefs() {
      const vm = this;

      this.columnDefs = [
        {
          headerName: '선택'
          , field:'regYn'
          , width : 50
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: {
            trueValue: "1"    //true값  지정 defalut-"Y" ex) "Y", true, "1"
            , falseValue: "0"  //false값 지정 defalut-"N" ex) "N", false, "0"
          },
        },
        {headerName:'ID', field:'userCd', width:50, editable:false},
        {headerName:'그룹구분', field:'groupNm', width:80, editable:false},
        {headerName:'직급', field:'positionCd',  width:80, editable:false},
        {headerName:'성명', field:'userNm',  width:40, editable:false},
        {headerName:'차량번호', field:'carNo',  width:40, editable:false},
        {headerName:'담당지역', field:'userNm',  width:40, editable:false},
        {headerName:'휴대폰', field:'userNm', width:40, editable:false},
        {
          headerName: '평일', children: [
            {headerName: '오전', field: 'weekMorning', width: 50, editable: false},
            {headerName: '오후', field: 'weekAfternoon', width: 50, editable: false},
          ], width: 100, editable: false
        },
        {
          headerName: '토요일', children: [
            {headerName: '오전', field: 'weekendMorning', width: 50, editable: false},
            {headerName: '오후', field: 'weekendAfternoon', width: 50, editable: false},
          ], width: 100, editable: false
        },
        {headerName:'', field:'userId', hide : true}
      ]

    },
    save(){

      if(this.form.userId == "") {
        this.$swal({type: 'warning', text: 'AS기사를 선택해주세요.'});
        return false;
      }


      this.$http
          .put('/api/asAgentMng/detail/agent/update',{
            companyId: this.$store.state.loginInfo.compCd,
            userId: this.form.userId,
            userCd: this.form.userCd,
            asAgentId: this.form.asAgentId,
            groupUid: this.form.groupUid,
            positionCd: this.form.positionCd,
            userNm: this.form.userNm,
            carNo: this.form.carNo,
            enterDt: this.form.enterDt,
            area: this.form.area,
            hpNo: this.form.hpNo,
            weekMorning: this.form.weekMorning,
            weekAfterNoon: this.form.weekAfterNoon,
            weekEndMorning: this.form.weekEndMorning,
            weekEndAfterNoon: this.form.weekEndAfterNoon,
            updatorId: this.$store.state.loginInfo.id,
            processTime: ""
          })
          .then(response => {
            this.$swal({ type: 'success', text: '저장되었습니다.' });
            this.goOpen();
          })
          .catch(({ message }) => {
            if (message === "Request failed with status code 500") {
              this.$swal({ type: "error", text: "오류가 발생했습니다." });
            }
          });
    },
    cancel(){
      this.form = _.clone(this.defForm);
    },
    getDateFormat(val) {
      if (val) {
        return val === 'null' ? '' : this.$moment(val).format('YYYY-MM-DD')
      }
    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/scheduleMng/init`)
          .then(response => {
            this.combos['agerntUser'] = response.data.agerntUser;  //AS기사
          }).finally(() => {
            //this.goOpen();
            this.$store.commit('finish');
          });
    },
  },
  beforeMount() {

    this.createColumnDefs(); //그리드 컬럼정의 함수 호출

    this.frameworkComponents = {//그리드에서 사용할 외부 comp 등록
      checkboxRenderer: CheckboxCellRenderer,
    };

  },
  mounted() {

  },
  watch: {
    custParam() {
      this.setInfo();
      this.data = this.custParam;
    },
  }
}

</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 0;
  // &:last-child {
  //   margin-bottom: 0;
  // }
}
.el-form {
  //border: 1px solid #c7c7c7;
  //padding: 10px 0 0 10px;
  //border-radius: 5px;
}
.el-form-item {
  margin-right: 10px;
  // &:last-child {
  //   margin-right: 0;
  // }
}
.large-textarea{
  padding: 0 24px !important
}
.el-select {
  width: 100%;
}

.el-row {
  border-bottom: 1px solid #d7d7d7;
  &:last-child {
    border-bottom: none;
  }
}

.components {
  border: 1px solid #d7d7d7 !important;
  padding: 10px 25px 10px 25px;
  border-radius: 5px;
}
</style>